import { useDispatch, useSelector } from "react-redux"
import { agregarFechaDiaAgente, obtenerCotizacionDiariosFechaAction } from "../../../ducks/reportesCotizacionesDuck"
import PickerMod from "../../../global/PickersMod"
import { endMounth, esFechaValida } from "../../../utils/FormatFecha"

const FiltroDia = () => {
    const dispatch = useDispatch()
    const { fechaDia } = useSelector(store => store.reporteCotizador)
    const handleChangeFechaMes = (date) => {
        if (!esFechaValida({ date })) {
            return null
        }
        dispatch(obtenerCotizacionDiariosFechaAction({ fecha: date }))
        dispatch(agregarFechaDiaAgente({dia: date}))
    }

    return (
        <PickerMod
            id="fechaFinalCotizaciones"
            label="Dia"
            selectedDate={fechaDia}
            setSelectedDate={handleChangeFechaMes}
            disablePast={false}
            disableFuture={true}
            formatFecha={"dd/MM/yyyy"}
            views={["year", "month", "date"]}
        />
    )
}
export default FiltroDia